import React from 'react';
import { PureComponent } from '../../../../dispatcher/modules';
import * as _ from 'lodash';
import PuzzleComboBox from './PuzzleComboBox';
import {
  PUZZLE_REMOTE_COMBO_PART_DATA_PROPS
} from './Types';
import uuid from 'uuid-random';
import virtualScrollCombo from '../../../../dispatcher/hoc/virtualScrollCombo';

/**
 * Remote data and filter combo box
 */
class PuzzleRemoteComboPartData extends PureComponent<PUZZLE_REMOTE_COMBO_PART_DATA_PROPS> {
  moduleId = uuid();
  comboRef: any;

  /**
   * Call external parseData function
   * @param data
   */
  parseData = (data: any) => {
    if (_.isFunction(this.props.parseData)) {
      data = this.props.parseData(data);
    }

    return data;
  };

  /**
   * Set data is function from virtual scroll component
   * preferably it should not be changed
   * @param data
   */
  setData = (data: any) => {
    _.get(this, 'props.setData') && this.props.setData(data);
  };

  renderBody() {
    let popupClass = 'data-preventrecorddeselect';

    if (this.props.virtual.total < 6) {
      popupClass += ' tp-remote-combo-box-popup';
    }

    return (
      <PuzzleComboBox
        {...this.props}
        popupSettings={{
          popupClass
        }}
        ref={(el: any) => {
          this.comboRef = el;
        }}
      />
    );
  }
}

export default virtualScrollCombo(PuzzleRemoteComboPartData);
